/**
 * @file コンポーネント：コンテンツメニュー DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import {
    StyledMenu,
    StyledMenuButton,
    StyledMenuList,
    StyledMenuListItem,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <StyledMenu ref={props.refContentsMenu}>
            <StyledMenuList>
                {/* 術前情報 */}
                {(props.hasPreoperation === true ||
                    props.isEditPage === true) && (
                    <StyledMenuListItem>
                        <StyledMenuButton
                            className={
                                props.selectedContentsData === "preoperation" &&
                                "is-active"
                            }
                            onClick={() =>
                                props.setSelectedContentsData("preoperation")
                            }
                        >
                            {localized["Label.PreOperation"]}
                        </StyledMenuButton>
                    </StyledMenuListItem>
                )}
                {/* フル動画 */}
                <StyledMenuListItem>
                    <StyledMenuButton
                        className={[
                            props.selectedContentsData === "fullvideo" &&
                                "is-active",
                            props.isEditPage !== true &&
                                props.isPaid === true &&
                                props.isPurchased === false &&
                                "is-dummy-disabled",
                        ]}
                        id="js-button-fullvideo" // common.jsでノートの動画ジャンプ時にこのIDの要素をクリックする処理がある
                        onClick={(e) => {
                            if (!window.dataUser.isLogin) {
                                // 非ログイン時にログインモーダルを出す
                                props.setIsOpenModalLogin(true);
                            } else if (
                                // 執刀医権限、管理者権限でない有料コンテンツかつ未購入の場合、決済情報ポップアップを強調表示
                                props.isEditPage !== true &&
                                props.isPaid === true &&
                                props.isPurchased === false
                            ) {
                                props.setIsHighlightPopupPayment(true);
                            } else {
                                // 上記以外の場合、メインコンテンツをフル動画に切り替え
                                props.setSelectedContentsData("fullvideo");
                            }
                        }}
                        title={
                            props.isPaid === true && props.isPurchased === false
                                ? localized["Label.PurchaseToPlayFullvideo"]
                                : null
                        }
                    >
                        {localized["Label.FullVideo"]}
                    </StyledMenuButton>
                </StyledMenuListItem>
                {/* 術後情報 */}
                {(props.hasPostoperation === true ||
                    props.isEditPage === true) && (
                    <StyledMenuListItem>
                        <StyledMenuButton
                            className={
                                props.selectedContentsData ===
                                    "postoperation" && "is-active"
                            }
                            onClick={() =>
                                props.setSelectedContentsData("postoperation")
                            }
                        >
                            {localized["Label.PostOperation"]}
                        </StyledMenuButton>
                    </StyledMenuListItem>
                )}
                {/* ダイジェスト動画 */}
                {props.hasDigest === true && (
                    <StyledMenuListItem>
                        <StyledMenuButton
                            className={
                                props.selectedContentsData === "digestvideo" &&
                                "is-active"
                            }
                            onClick={(e) => {
                                if (!window.dataUser.isLogin) {
                                    // 非ログイン時にログインモーダルを出す
                                    props.setIsOpenModalLogin(true);
                                } else {
                                    props.setSelectedContentsData("digestvideo")
                                }
                            }}
                        >
                            {localized["Label.Digest"]}
                        </StyledMenuButton>
                    </StyledMenuListItem>
                )}
                {/* ポイントコンテンツ */}
                {props.hasPointcontents === true && (
                    <StyledMenuListItem>
                        <StyledMenuButton
                            className={
                                props.selectedContentsData ===
                                    "pointcontents" && "is-active"
                            }
                            onClick={(e) => {
                                if (!window.dataUser.isLogin) {
                                    // 非ログイン時にログインモーダルを出す
                                    props.setIsOpenModalLogin(true);
                                } else {
                                    props.setSelectedContentsData("pointcontents")
                                }
                            }}
                        >
                            {localized["Label.Pointcontents"]}
                        </StyledMenuButton>
                    </StyledMenuListItem>
                )}
                {/* 概要 */}
                {(props.isEditPage === true ||
                    props.adOperationSummary !== null ||
                    props.listSurgicalEquipment.length > 0 ||
                    props.summary !== null) && (
                    <StyledMenuListItem>
                        <StyledMenuButton
                            className={
                                props.selectedContentsData === "summary" &&
                                "is-active"
                            }
                            onClick={() =>
                                props.setSelectedContentsData("summary")
                            }
                        >
                            {localized["Label.Summary"]}
                        </StyledMenuButton>
                    </StyledMenuListItem>
                )}
            </StyledMenuList>
        </StyledMenu>
    );
};
